import React, { useState } from "react";
import { hireDevOpsFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";

const DevOpsEngineers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10">
          <div className="lg:w-3/4 lg:text-left">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Expert DevOps Engineers in India
            </h2>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              Looking to launch and deploy your products seamlessly? DevOps is
              the key to achieving that. Organizations that embrace the DevOps
              culture, tools, and practices excel in creating high-performance,
              collaborative, and fast-delivering products and services. Hire our
              team of DevOps engineers at Ayanshtech to integrate the best
              development and operational processes into a unified approach.
              <br /> <br />
              So, why wait? If you aim to accelerate your product's time to
              market and outperform competitors, now is the perfect time to hire
              a DevOps team from Ayanshtech. Our engineers possess deep
              expertise in the latest tools, techniques, methodologies, and
              processes that drive productivity, enhance collaboration, and help
              you achieve your business objectives.
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a DevOps Engineer
            </button>
          </div>

          <div className="flex justify-center mb-12 lg:mb-0 mt-5">
            <img
              src="\assets\images\headerSection\hireDevopsEng\img1.png"
              alt="DevOps Engineering Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Hire Our Expert DevOps Engineers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Our skilled DevOps engineers are equipped to handle sophisticated
          solutions that drive business growth. At Ayanshtech, our programmers
          specialize in providing high-quality DevOps services to help you scale
          efficiently.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon1.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Cloud Solution DevOps</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Automation in DevOps</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Seamless DevOps Integration</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">DevOps Configuration & Maintenance</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">DevOps Consulting Services</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Management of Infrastructure</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon7.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Version Control & Source Code Management</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon8.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">DevOps for Cloud Solutions</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Hire Experienced DevOps Engineers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Engage skilled DevOps engineers who seamlessly integrate people,
          processes, and technology to enhance product development and customer
          satisfaction. This enables you to respond swiftly to customer demands.
          At Ayanshtech, we connect you with the best DevOps professionals to
          accelerate your business success.
        </p>
      </div>

      <div className="">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireDevopsEng\img2.png"
              alt="Laptop with graph"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our experts can help deploy software seamlessly across testing
                  and production environments with minimal effort.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  The DevOps engineers and managers at Ayanshtech are certified
                  professionals, highly trained and proficient in the latest
                  technologies.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Whether you need containerization, orchestration, or server
                  support and security, our team delivers tailored solutions to
                  meet your needs.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our engineers possess deep expertise in automation platforms,
                  enabling them to efficiently review and optimize your code.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      {/* <div className="max-w-3xl mx-auto p-4 mt-10 w-full">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {hireDevOpsFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div> */}

       <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
                FAQs
            </h2>
            <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

                <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
                    {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
                    {hireDevOpsFaqs.map((faq, index) => (
                        <div key={index} className="border-b-2 border-blue-300">
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                                    : ""
                                    }`}
                            >
                                <span className="text-lg">{faq.question}</span>
                                <span className="text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 text-gray-700">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>

                <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
                    {" "}
                    <Contact />
                </div>


            </div>

      <GetInTouch />
    </div>
  );
};

export default DevOpsEngineers;
